import { doctorBffApi } from '@/modules';
import { wrapError } from '@/modules/error/errorHandlers';
import {
  AgeBucket,
  MhoCategory,
  MhoSuggestion,
  MhoSuggestionCreateRequest,
  RuleGender
} from './mhoSuggestions.model';
import { Emphasis } from '@/modules/surgicalEvent';
import {
  MhoSuggestionCreateResult,
  MhoSuggestionsService
} from './mhoSuggestions.service';

export const mhoSuggestionsApi = doctorBffApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getMhoSuggestions: builder.query<MhoSuggestion[], void>({
      keepUnusedDataFor: 10 * 60,
      providesTags: ['MhoSuggestions'],
      queryFn: () =>
        MhoSuggestionsService.list()
          .then((r) => ({ data: r.data }))
          .catch(wrapError)
    }),

    createMhoSuggestion: builder.mutation<
      MhoSuggestionCreateResult,
      MhoSuggestionCreateRequest
    >({
      invalidatesTags: ['MhoSuggestions'],
      queryFn: (body) =>
        MhoSuggestionsService.create(body)
          .then((r) => ({ data: r }))
          .catch(wrapError)
    }),

    deleteMhoSuggestionForFilter: builder.mutation<
      void,
      { id: number; gender: RuleGender; ageBucket: AgeBucket }
    >({
      invalidatesTags: ['MhoSuggestions'],
      queryFn: ({ id, gender, ageBucket }) =>
        MhoSuggestionsService.deleteForFilter(id, gender, ageBucket)
          .then(() => ({ data: {} as any }))
          .catch(wrapError)
    }),

    updateMhoSuggestionEmphasis: builder.mutation<
      MhoSuggestion,
      { id: number; defaultEmphasis: Emphasis }
    >({
      invalidatesTags: ['MhoSuggestions'],
      queryFn: ({ id, defaultEmphasis }) =>
        MhoSuggestionsService.updateEmphasis(id, { defaultEmphasis })
          .then((r) => ({ data: r.data }))
          .catch(wrapError)
    }),

    reorderMhoSuggestions: builder.mutation<
      void,
      { category: MhoCategory; orderedIds: number[] }
    >({
      invalidatesTags: ['MhoSuggestions'],
      queryFn: (body) =>
        MhoSuggestionsService.reorder(body)
          .then(() => ({ data: {} as any }))
          .catch(wrapError)
    }),

    resetMhoSuggestions: builder.mutation<
      MhoSuggestion[],
      { category: MhoCategory; includeCustom: boolean }
    >({
      invalidatesTags: ['MhoSuggestions'],
      queryFn: (body) =>
        MhoSuggestionsService.reset(body)
          .then((r) => ({ data: r.data }))
          .catch(wrapError)
    })
  })
});

export const {
  useGetMhoSuggestionsQuery,
  useCreateMhoSuggestionMutation,
  useDeleteMhoSuggestionForFilterMutation,
  useUpdateMhoSuggestionEmphasisMutation,
  useReorderMhoSuggestionsMutation,
  useResetMhoSuggestionsMutation
} = mhoSuggestionsApi;
